import React, {Component} from "react";
import styles from "./CheckBox.module.css";
import PropTypes from "prop-types";
import {withTranslation} from "react-i18next";

const defaultProps = {
    text: ""
};
const propTypes = {
    title: PropTypes.text,
    onChange: PropTypes.func,
    checked: PropTypes.bool,
}

class CheckBox extends Component {
    state = {
        checked: this.props.checked,
        disabled: false,
        index: this.props.index,
        row: null
    };

    constructor(props) {
        super(props);
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (prevProps.checked !== this.props.checked) {
            this.setState({
                // disabled: disabled,
                checked: this.props.checked,
                index: this.props.index,
                row: this.props.row ? this.props.row : null
            })
        }
    }

    handleOnChange(e) {
        if (this.props.row) {  //se è una checkbox in una tabella
            //aggiorno lo stato "checked" e la riga selezionata
            let selected = this.props.row
            if (this.props.fieldName)
                selected[this.props.fieldName] = e.target.checked;
            else
                selected["checked"] = e.target.checked;
            this.setState({checked: e.target.checked, row: selected});
        }

        if (this.props.onChange && this.props.newCheckbox) {
            e.target.value = e.target.checked
            this.props.onChange(this.props.id, e, this.props.isRadio, this.props.fieldName ? this.props.fieldName : null);
        } else if (this.props.onChange) {  //handleChangess della table - input deve avere indice, valore e isRadio
            this.props.onChange(this.props.index, e.target.checked, this.props.isRadio, this.props.fieldName ? this.props.fieldName : null, this.props.rows);
        }

    }


    render() {
        const {t} = this.props

        const {
            ...attributes
        } = this.props
        let css = (this.props.parentClass != null && "" != this.props.parentClass) ? "form-check ".concat(this.props.parentClass) : "form-check ";

        if (!this.state.checked && this.props.deselectStyle) {
            css = css.concat(" ").concat(styles.formCheckMod)
        }

        let styleContenuto = {
            display: "inline-block",
            paddingLeft: "10px", paddingTop: "0.5px", fontSize: "13px", color: "black"
        }

        return <div className={styles.checkBoxItem} style={this.props.chkStyle}>
            <div
                className={css}
            >
                <input
                    {...attributes}
                    //this.props.isRadio ? this.props.selectedRow.checked ?  true : false : this.state.checked
                    checked={this.props.checked}  //this.props.isRadio ? this.props.selectedId == this.state.rowIndex ?  true : false : this.state.checked
                    disabled={this.props.disabledFlag ? this.props.disabledFlag : false}
                    onChange={e => this.handleOnChange(e)}
                    id={this.props.id ? this.props.id : "checkbox1"}
                    type="checkbox"
                    className=""
                />
                {this.props.contenutoCheckBox ?
                    <label for={this.props.id}
                           style={this.props.styleContenuto ? this.props.styleContenuto : styleContenuto}>
                        {this.props.contenutoCheckBox}</label> : ""}
                <label className={styles[this.props.chkClassNameLabel]}
                       style={{
                           display: this.props.contenutoCheckBox ? "inline-block" : "",
                           marginLeft: this.props.contenutoCheckBox ? "1rem" : "",
                           fontSize: this.props.contenutoCheckBox ? "18px" : this.props.fontSize,
                           color: this.props.contenutoCheckBox ? "black" : this.props.fontColor,
                           fontWeight: this.props.fontWeight ? this.props.fontWeight : ""
                       }}
                       htmlFor={this.props.id ? this.props.id : "checkbox1"}>
                    {this.props.text}
                </label>
            </div>
            {this.props.required ?
                <label htmlFor={this.state.id ? this.state.id : "checkbox1"}
                       style={{color: "black", fontSize: "14px"}}
                >{t("Utils.opzione")}<span style={{color: "red"}}>*</span>
                </label> : ""}
        </div>
    }
}

CheckBox.propTypes = propTypes
CheckBox.defaultProps = defaultProps
export default withTranslation('common')(CheckBox)
